import React, {  useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import ActivitiesList from '@components/ContentComponents/Activities/ActivitiesList';
// import UserEventHistory from '@components/ContentComponents/Events/UserEventHistory';
import RewardLevels from '@components/ContentComponents/Member/RewardLevels';
import TotalScore from '@components/ContentComponents/Member/TotalScore';
import UserContext from '@lib/contexts/userContext';

const Activities = () => {
  // const [userEvents, setUserEvents] = useState([]);
  // const [subTotals, setSubTotals] = useState(0);

  const { userRecord } = useContext(UserContext);
  // console.log('[Activities] userRecord = ', userRecord);

  // let userID = userRecord?.id;

  // Removed until User Events tracking is re-implemented - KD 2025-07-22
  // const calcSubTotals = async (userEvents) => {
  //   if (typeof userEvents !== 'undefined' && userEvents.length > 0) {
  //     let score = userEvents.reduce((points, event) => {
  //       if (!points[event.event_type]) {
  //         points[event.event_type] = event.points;
  //       } else {
  //         points[event.event_type] = points[event.event_type] + event.points;
  //       }
  //       // console.log("points: ", points)
  //       return points;
  //     }, {});
  //     setSubTotals(score);
  //   }
  // };
  //
  // useEffect(() => {
  //   calcSubTotals(userEvents).then();
  // }, [userEvents]);
  //
  // useEffect(() => {
  //   if (userID) {
  //     fetchUserEvents(userID).then((userEventsList) => setUserEvents(userEventsList));
  //   } else {
  //     setUserEvents([]);
  //   }
  // }, [userID]);
  // End User Events tracking code

  const rewardsSidebar = (
    <Box sx={{ maxWidth: '324px' }}>
      <TotalScore userScore={userRecord?.points} />
      <RewardLevels/>
    </Box>
  );

  return (
    <Grid container spacing={2} columns={20}>
      <Grid item lg={15} xl={16}>
        <Grid container spacing={0} columns={20}>
          {/* Removed until User Events tracking is re-implemented - KD 2025-07-22 */}
          {/*<Grid item order={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 1  }} xs={20} lg={20} xl={9} paddingRight={'15px'} mb={'15px'}>*/}
          {/*  <UserEventHistory*/}
          {/*    events={userEvents}*/}
          {/*    subTotals={subTotals}*/}
          {/*  />*/}
          {/*</Grid>*/}
          <Grid item order={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 2 }} xs={20} lg={20} xl={11} mb={'15px'}>
            <ActivitiesList />
          </Grid>
        </Grid>
      </Grid>

      <Grid item lg={5} xl={4}>
        { rewardsSidebar }
      </Grid>
    </Grid>
  );
};

export default Activities;
